import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { copyFileSync } from 'fs';

export const PrivateRoute = ({ children }: { children: any }) => {
  const { isLoading, isAuthenticated, loginWithRedirect, logout, user } = useAuth0();
  const location = useLocation();

  const guestMFAEnabled = process.env.REACT_APP_USE_GUESTMFA === '1';

  const appMetadata = (guestMFAEnabled && user) ? user["https://dk-connect-bm.com/app_metadata"] : null;
  const isGuest = !appMetadata ? false : appMetadata.is_guest || false;

  // ゲストモードで通常ログインが行われた
  // → ゲストログインセッションが残っているため、これを削除して通常ログインを行う
  useEffect(()=> {
    if (isGuest && isAuthenticated) {
      logout();
    }
  });

  console.log(user);
  
  useEffect(() => {
    if (isLoading || isAuthenticated) return;
    /**
    * v1.4.5 Issue#648 ログインしていない状態で「予定確定メール」内にある各URLをクリックした場合、期待するページ以外に遷移する
    * クエリパラメータの値を渡すように修正
    */
    loginWithRedirect({ appState: { returnTo: `${location.pathname}${location.search}` } });
   }, [isLoading, isAuthenticated, loginWithRedirect, location.pathname,location.search]);

  return isAuthenticated ? children : isLoading ? <></> : <Navigate to="/login" />;
};


export const GuestMFARoute = ({ children }: { children: any }) => {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();
  const location = useLocation();
  const [guestMfaPassed, setGuestMfaPassed] = useState<boolean>(false);
  if (isAuthenticated && !guestMfaPassed) {
    setGuestMfaPassed(true);
  }

  useEffect(() => {
    if (isLoading || isAuthenticated) return;
    loginWithRedirect({ appState: { returnTo: `${location.pathname}${location.search}` } });
  }, [location.pathname,location.search]);

  if (guestMfaPassed) {
    return isLoading ? <></> : children;
  }
  return isAuthenticated ? children : isLoading ? <></> : <Navigate to="/login" />;
};
